import { GET_CURRENT_TIME } from './constants';

type Response = {
    time: number;
};

export default (): Promise<Response> => {
    return fetch(GET_CURRENT_TIME, {
        method: 'GET',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to fetch current time from api');
        }
    });
};
